import React, { useEffect, useState } from 'react'

import FormGroup from '@mui/material/FormGroup';

import Typography from '@mui/material/Typography';

import CardContent from '@mui/material/CardContent';

import Card from '@mui/material/Card';

import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { ThemeProvider } from '@emotion/react';
import {theme} from '../../theme'

function SpecSingle(props) {
  const spec = props.spec
  const idddd = props.id
  const [listState, setListState] = useState([]);
  const [selected, setSelected] = useState([])
  const [currentRange, setCurrentRange] = useState(0)
  const spec_list = [{ unique_id: '', list: [] }]
  const list = spec.list
  var range = spec.range
  list.map((item) => {
    if (!item.state) {
      item.state = false
    }
  })


  console.log('to check this', selected)
  useEffect(() => {
    setListState(list)
  }, [])
  useEffect(() => {
    var specee = { unique_id: spec.unique_id, list: selected }
    if (specee.list.length == 0) {
      return
    }
    props.updateSpec({}, specee)
  }, [selected])
  const find_true = () => {
    var temp = []

  }
  const handleSelf = (event, id) => {
    console.log('idi', id)
    console.log(event)
    var set = event.target.checked
    console.log('set', set)
    var temp_list = listState
    console.log(temp_list)
    for (let i = 0; i < temp_list.length; i++) {
      if (set) {
        console.log('setting true')
        if (spec.type == 1) {
          console.log('type is 1')
          // props.removeReq(temp_list[i],spec)
          if (temp_list[i]._id == id) {
            console.log('found', temp_list[i])
            temp_list[i].state = true
            console.log('updated', temp_list[i])
            setSelected([temp_list[i]])

          } else {
            temp_list[i].state = !event.target.checked
            var temp = selected
            const index = temp.indexOf(temp_list[i]);
            console.log('before remove', selected)
          }

        } else {
          if (temp_list[i]._id == id) {
            console.log('found', temp_list[i])
            temp_list[i].state = true
            console.log('updated', temp_list[i])
            var dg = selected
            dg.push(temp_list[i])
            setSelected(dg)
            // setSelected([...selected,temp_list[i]])
            var specee = { unique_id: spec.unique_id, list: selected }
            console.log('sadasdfghjklf', specee)
            props.updateSpec(temp_list[i], specee)
            // props.updateSpec(temp_list[i],spec)
          }
        }
      } else {
        if (temp_list[i]._id == id) {
          console.log('found', temp_list[i])
          temp_list[i].state = set
          console.log('updated', temp_list[i])

          var temp = selected
          const index = temp.indexOf(temp_list[i]);
          console.log('before remove', selected)
          if (index > -1) {
            temp.splice(index, 1);
          }
          setSelected(temp)
          var specee = { unique_id: spec.unique_id, list: selected }
          props.updateSpec(temp_list[i], specee)
        }
      }
    }
    console.log(temp_list)
    setListState([...temp_list])
  }
  return (
    <div sx={{ maxWidth: 345 }}>
        <div style={{fontSize:'0.9rem'}}>{spec.name}</div>
        {spec.is_required ? <p style={{color:'red'}}>Required</p> : null}
        {listState.map((item) => (
          <>
          <ThemeProvider theme={theme}>
            <Typography variant="body2" color="text.secondary" style={{margin:'0px',  border:'none'}}>
              <FormControlLabel   control={<Checkbox  
              color='neutral'
              style={{ fontSize:'0.6rem', padding:'5px'}}
              checked={item.state} size='small' onChange={(event) => { handleSelf(event, item._id) }} />} 
             label= {<span style={{ fontSize: '0.7rem' }}>{item.name}Br.{item.price}</span>}/>
           
              
            </Typography>
            </ThemeProvider>
            {/* <SpecSingle spec = {item}></SpecSingle> */}
          </>

        ))}
    </div>
  )
}
export default SpecSingle
